import { render, staticRenderFns } from "./FittingsHome.vue?vue&type=template&id=8a2155cc&scoped=true"
import script from "./FittingsHome.vue?vue&type=script&lang=js"
export * from "./FittingsHome.vue?vue&type=script&lang=js"
import style0 from "./FittingsHome.vue?vue&type=style&index=0&id=8a2155cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2155cc",
  null
  
)

export default component.exports